import { Types } from './actionTypes';

const initialState = {
  profile: {
    userName: '',
    name: '',
    emailId: '',
    salesPersonId: 0
  },
  party: null,
  sale: null,
  isUserLoggedIn: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.LOGIN:
      return {
            ...state,
            profile: action.payload.user,
            isUserLoggedIn: true
      }
    case Types.LOGOUT:
      return {
            ...state,
            profile: initialState.profile,
            isUserLoggedIn: false
        }    
    case Types.SELECT_CUSTOMER:
          return {
                ...state,
                party: action.payload
          }
    case Types.SELECT_SALE:
          return {
                ...state,
                sale: action.sale
          }
    default:
      return state;
  }
}

export default reducer;